import React, { Fragment } from "react";

const sugPrefix = "sug";
const placeIconPng = "//maps.gstatic.com/consumer/images/icons/1x/place_grey650.png";

export const LocationSuggestions = ({ suggestions, onSelect }) => {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <Fragment>
      {suggestions.map((suggestion, idx) => (
        <div
          className="cbmap-suggestion-item"
          key={`${sugPrefix}loc-${idx + 1}`}
          tabIndex="0"
          id={`${sugPrefix}-${idx + 1}`}
          data-location-id={`${suggestion.uid}`}
          onClick={(e) => onSelect(suggestion)}
        >
          <img alt="" src={placeIconPng} />
          <span>
            <span>
              <strong>{suggestion.name}</strong>
            </span>
            <br />
            <span>{suggestion.full_address}</span>
          </span>
        </div>
      ))}
    </Fragment>
  );
};

export const AddressSuggestions = ({ suggestions, startIdx = 0, onSelect }) => {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <Fragment>
      {suggestions.map((suggestion, idx) => (
        <div
          className="cbmap-suggestion-item"
          key={`${sugPrefix}addr-${suggestion.place_id}`}
          tabIndex="0"
          id={`${sugPrefix}-${startIdx + idx}`}
          data-place-id={`${suggestion.place_id}`}
          onClick={(e) => onSelect(suggestion)}
        >
          <img alt="" src={placeIconPng} />
          <span>{suggestion.description}</span>
        </div>
      ))}
    </Fragment>
  );
};